import {
  createActions,
  keyMirror,
  standardActions,
} from '@groove-labs/action-utils';

export const actionTypes = createActions({
  HOME: {
    FETCH_UPCOMING_ACTIVITIES: standardActions(),
    FETCH_UPCOMING_EMAIL_NOTIFICATIONS: standardActions(),
    UPDATE_EMAIL_MUTE_OPEN: standardActions(),
    SET_NOTIFICATION_TAB: standardActions(),
    ...keyMirror([
      'LOAD_MAIN_DATA',
      'RESET_REDUCER',
      'REQUEST_MORE_NOTIFICATIONS',
      'UPDATE_NOTIFY_QUERY',
      'SET_EXPANDED_NOTIFICATIONS',
      'REFRESH_UPCOMING_ACTIVITIES',
      'FLOW_ACTION_LINK_CLICKED',
    ]),
  },
}).HOME;

export const flowActionLinkClicked = ({ action }) => {
  return {
    type: actionTypes.FLOW_ACTION_LINK_CLICKED,
    payload: { action },
  };
};

export function loadMainData({ flowSummary, activityIntelFeed }) {
  return {
    type: actionTypes.LOAD_MAIN_DATA,
    payload: { flowSummary, activityIntelFeed },
  };
}

export function upcomingActivitiesFetchBegin() {
  return {
    type: actionTypes.FETCH_UPCOMING_ACTIVITIES.BEGIN,
  };
}

export function upcomingActivitiesFetchSuccess({ upcomingActivitiesData }) {
  return {
    type: actionTypes.FETCH_UPCOMING_ACTIVITIES.SUCCESS,
    payload: { upcomingActivitiesData },
  };
}

export function upcomingActivitiesFetchFailure() {
  return {
    type: actionTypes.FETCH_UPCOMING_ACTIVITIES.FAILURE,
  };
}

export function emailNotificationsFetchBegin() {
  return {
    type: actionTypes.FETCH_UPCOMING_EMAIL_NOTIFICATIONS.BEGIN,
  };
}

export function updateEmailNotificationData(
  emailNotification,
  overwrite = false
) {
  return {
    type: actionTypes.FETCH_UPCOMING_EMAIL_NOTIFICATIONS.SUCCESS,
    payload: { emailNotification, overwrite },
  };
}

export function requestMoreNotifications() {
  return {
    type: actionTypes.REQUEST_MORE_NOTIFICATIONS,
  };
}

export function updateNotifyQuery(payload) {
  return {
    type: actionTypes.UPDATE_NOTIFY_QUERY,
    payload,
  };
}

export function setExpandedNotifications(notificationId) {
  return {
    type: actionTypes.SET_EXPANDED_NOTIFICATIONS,
    payload: notificationId,
  };
}

export function beginUpdateEmailMuteOpen(id, mute) {
  return {
    type: actionTypes.UPDATE_EMAIL_MUTE_OPEN.BEGIN,
    payload: { emailId: id, muteStatus: mute },
  };
}

export function emailMuteSuccess(emailId, muteDate) {
  return {
    type: actionTypes.UPDATE_EMAIL_MUTE_OPEN.SUCCESS,
    payload: { emailId, muteDate },
  };
}

export function refreshUpcomingActivities() {
  return {
    type: actionTypes.REFRESH_UPCOMING_ACTIVITIES,
  };
}
